import Components from './components/';
import Constants from './constants/';
import Models from './models/';
import Services from './services/';
export default angular.module('searchEngineFrontend.searchInterface.shared', [
  Components.name,
  Constants.name,
  Models.name,
  Services.name
]);



// WEBPACK FOOTER //
// ./src/search-interface/shared/index.js